import { createApiModules } from "@repo/share-log-api-client";
import { baseHttpClient } from "@web/api/http-client";

export const API = createApiModules(baseHttpClient);
